/**
 * ACCOUNT-LOGO
 * Logo of the connected account
 */
import { connect } from "react-redux"
import { AccountState } from "@/redux/account.types"
import { Session } from "@/redux/_session.types"
import { getImageUrl } from "@/utils/get-image-url"
import { NavigateFunction, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHome } from "@fortawesome/free-solid-svg-icons"

interface StateProps {
  _session: Session
  superadmin: AccountState
}

function AccountLogoWidget(props: StateProps) {
  const navigate: NavigateFunction = useNavigate()

  const homeRoute = "/home"

  return (
    <div
      className="flex"
      style={{
        backgroundColor: window.location.pathname === homeRoute ? "#0000001a" : "initial"
      }}>
      {props._session.accountOptions.image ? (
        <img
          alt="account"
          className="page-navigation-circle-img"
          onClick={() => navigate(homeRoute)}
          src={getImageUrl("Accounts", props._session.accountId, props._session.logoLastUpdate)}></img>
      ) : (
        <div className="page-navigation-circle-img flex _hover" onClick={() => navigate(homeRoute)}>
          <FontAwesomeIcon style={{ fontSize: 18 }} icon={faHome} className="white-t flex-auto" />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  _session: state._session,
  superadmin: state.superadmin
})

export default connect(mapStateToProps)(AccountLogoWidget)
